export type Role = "ADMIN" | "OPERATOR" | "TICKET_CREATOR" | "VIEWER"
export const defaultRole: Role = "VIEWER"

export type Resource =
  | "issues"
  | "tickets"
  | "labels"
  | "integrations"
  | "settings.scopes"
  | "settings.users"
  | "settings.auth"
  | "settings.labels"
  | "settings.code-scan"
  | "settings.service-keys"
  | "settings.deployment-keys"
  | "settings.system-status"
  | "settings.kai-configurations"
  | "scm.policies"
  | "scm.policy-exceptions"
  | "ci.policies"
  | "code.policies"
  | "governance.workflows"
  | "governance.scan-history"
  | "ai.policies"
  | "system"
  | "incidents"
  | "reports"
  | "*"

export type Action = "read" | "write" | "*"

export type RolePolicies = Partial<
  Record<Role, Partial<Record<Resource, Action[]>>>
>

export interface Permission {
  resource: Resource
  action: Action
}
